<template>
  <div class="common-empty-record">
    <i class="iconfont">&#xe636;</i>
    <p>没有找到相关记录</p>
  </div>
</template>

<script>

export default {
  name: 'EmptyRecord',
  data () {
    return {

    }
  },
  props: {

  },
  methods: {

  }
}
</script>
